import React from "react";
import defaultImage from '../../assets/images/Default_user_image.png';
import Linkedin from "../../assets/images/khoj-images/linkedin.png";
import testImage from '../../assets/images/khoj-images/images.jpg';
import Subrat_Kumar_ from "../../assets/images/khoj-images/Subrat_Kumar_.jpg"
import saumitra_sir_ from "../../assets/images/khoj-images/saumitra_sir_.png"

Iconbox3.propTypes = {};

function Iconbox3(props) {
	return (
		<section className="inner-review-section-two ">
			<div className="container ">

				<div className="row text-center Proud-partner">
					<div className="col-md-12 mb-3 mt-4 ">
						<h2 className="mb-2">Meet with partners</h2>
					</div>
				</div>

				{/* Laptop and Tablet */}
				<div className="row aln-center-mb meet-container meet-partener-first-card">
					<div className="col-lg-6 d-flex meet-partners-two">
						<div className="row meet-cards">
							<div className="col-md-6 p-0">
								<div className="wd-review-job thumb-style3 p-4 pt-2">
									<div>
										<p className="meet-patner-P-one">"Too often, we ask the impossible—expecting a fish to soar and a bird to dive. But true power lies in recognizing the unique strengths of each and placing them in spaces where they can thrive. Khoj is where that synergy takes place, unlocking boundless possibilities and creating a ripple of change that resonates across industries and lives — because the world is waiting for what only you can offer."  </p>
									</div>
									<div className="d-flex">
										<div className="group-heading mb-0">
											<h5 className="f-600 mb-0">Dr. Subrat Kumar </h5>
											<p className="f-12 mb-0">CEO, People Labs</p>
										</div>
										<a href="https://www.linkedin.com/in/dr-subrat-kumar-20970a8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app">
											<div className="social-image"><img src={Linkedin} alt="" srcset="" /></div>
										</a>
									</div>
								</div>
							</div>
							<div className="col-md-6 p-0">
								<div className="partners-iamge meet-img">
									<img src={Subrat_Kumar_} alt="" srcset="" />
								</div>
							</div>

						</div>
					</div>

					<div className="col-lg-6 d-flex meet-partners-two">
						<div className="row meet-cards">

							<div className="col-md-6 p-0 ">
								<div className="wd-review-job thumb-style3 p-4 pt-2">
									<div>
										<p> "At Khoj, the focus isn’t just on connecting the dots—it’s on helping you see the vast
											canvas ahead. Understanding that your journey isn’t linear, we believe the path to success
											shouldn’t be either. In a rapidly evolving world, technology isn’t just a tool—it’s the compass
											that helps you navigate, adapt, and explore the unknown. With innovation in your corner, you have
											the power to chart your own path and create an impact that’s uniquely yours, on your own terms."
										</p>
									</div>
									<div className="d-flex">
										<div className="group-heading mb-0">
											<h5 className="f-600 mb-0">Mr. Saumitra Sawarni </h5>
											<p className="f-12 mb-0">CTO, People Labs</p>
										</div>
										<a href="https://www.linkedin.com/in/saumitra-sawarni-3aaa9b5?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app">
											<div className="social-image"><img src={Linkedin} alt="" srcset="" /></div>
										</a>

									</div>
								</div>
							</div>
							<div className="col-md-6 p-0">
								<div className="partners-iamge meet-img">
									<img src={saumitra_sir_} alt="" srcset="" />
								</div>
							</div>
						</div>


					</div>


				</div>

				{/*.................................... mobile .......................................*/}
				<div className="row aln-center-mb meet-container-mobile">
					<div className="col-lg-6 d-flex meet-partners-one">
						<div className="row meet-cards">
							<div className="col-md-6 p-0" style={{ justifyContent: "center", display: "flex" }}>
								<div className="wd-review-job thumb-style3 p-4 pt-2">
									<div className="d-flex pb-2">
										<div className="group-heading mb-0">
											<h5 className="f-600 mb-0">Dr. Subrat Kumar </h5>
											<p className="f-12 mb-0">CEO, People Labs</p>
										</div>
										<a href="https://www.linkedin.com/in/dr-subrat-kumar-20970a8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app">
											<div className="social-image"><img src={Linkedin} alt="" srcset="" /></div>
										</a>
									</div>

									<div className="partners-iamge-mobileview" style={{ justifyContent: "center", display: "flex" }}>
										<img src={Subrat_Kumar_} alt="" srcset="" />

									</div>

									<div>
										<p className="mt-3">" Too often, we ask the impossible—expecting a fish to soar and birds to dive.
											But true power lies in recognizing the unique strengths of each and placing them in spaces where they can thrive. KHOJ
											is where that synergy takes place, unlocking boundless possibilities and creating a ripple of change that resonates across
											industries and lives — because the world is waiting for what only you can offer. "
										</p>
									</div>

								</div>
							</div>

						</div>


					</div>

					<div className="col-lg-6 d-flex meet-partners-two">
						<div className="row meet-cards">

							<div className="col-md-6 p-0 ">
								<div className="wd-review-job thumb-style3 p-4 pt-2">
									<div className="d-flex pb-2">
										<div className="group-heading mb-0">
											<h5 className="f-600 mb-0">Mr. Saumitra Sawarni </h5>
											<p className="f-12 mb-0">CTO, People Labs</p>
										</div>
										<a href="https://www.linkedin.com/in/saumitra-sawarni-3aaa9b5?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app">
											<div className="social-image"><img src={Linkedin} alt="" srcset="" /></div>
										</a>

									</div>

									<div className="partners-iamge-mobileview" style={{ justifyContent: "center", display: "flex" }}>
										<img src={saumitra_sir_} alt="" srcset="" />

									</div>

									<div>
										<p className="mt-3"> " At KHOJ, the focus isn’t just on connecting the dots—it’s on helping you see the vast canvas ahead. Understanding that your journey isn’t linear, we believe the path to success shouldn’t be either. In a rapidly evolving world, technology isn’t just a tool—it’s the compass that helps you navigate, adapt, and explore the unknown. With innovation in your corner, you have the power to chart your own path and create an impact that’s uniquely yours, on your own terms. "
										</p>
									</div>

								</div>
							</div>
							{/* <div className="col-md-6 p-0 meet-partners-two-card">
								<div className="partners-iamge">
									<img src={saumitra_sir_} alt="" srcset="" />
								</div>
							</div> */}
						</div>


					</div>


				</div>
			</div>
		</section>
	);
}

export default Iconbox3;
